export default "__VITE_ASSET__D038utMW__"